@if (element[columnName] | isStringArray) {
  @for (element of element[columnName]; track $index) {
    <div>
      {{ element }}
    </div>
  }
} @else {
  @if (parseLinks) {
    <div [innerHTML]="element[columnName] | parseHttpsLinks"></div>
  }
  @if (!parseLinks) {
    {{ element[columnName] }}
  }
}
